import { RcBuildEnvironment } from './environment.model';

// Cloud build: all environment values are resolved at runtime from
// public/config/config.<env>.json (loaded via provideEnvironmentConfig), so only the
// deployment discriminator is baked in here. See TARE-18657.
export const environment: RcBuildEnvironment = {
  deploymentTarget: 'cloud',
};
